import { URL_SEARCH } from "../../../lib/constants/urls/urlSearch";
import { URL_SEARCH_SERVICE } from "../../../lib/constants/urls/urlSearchService";
import { parishSearchResultSchema } from "../../../lib/types/schema/search/parishSearchResultSchema";
import { request } from "../../../request/request";
import { PARISH_SEARCH_DIRECTORY } from "./constants/elasticSearchDirectory.constants";

export type ParishSearchFilters = { status?: Array<"active" | "launched"> };

export type ParishSearchOptions = {
  /** Route to Hallow's search service (`web_search_service` flag) instead of Elastic. */
  searchService?: boolean;
};

export const requestParishSearchRequestProps = (
  search: string,
  filters: ParishSearchFilters,
  { searchService = false }: ParishSearchOptions = {},
) => ({
  body: JSON.stringify({
    filters,
    query: search,
  }),
  method: "POST",
  requestType: searchService ? ("searchService" as const) : ("search" as const),
  schema: parishSearchResultSchema,
  url: searchService
    ? `${URL_SEARCH_SERVICE}/parishes/search`
    : `${URL_SEARCH}/${PARISH_SEARCH_DIRECTORY}/search`,
});

export const requestParishSearch = async (
  search: string,
  filters: ParishSearchFilters = {
    status: ["active", "launched"],
  },
  options: ParishSearchOptions = {},
) =>
  request({
    ...requestParishSearchRequestProps(search, filters, options),
  });
